__turbopack_context__.v({
  "className": "JWbPuG_className",
  "variable": "JWbPuG_variable",
});
